export const ALLOWED_TYPES  = ['image/jpeg', 'image/png', 'image/jpg'];
export const MAX_SIZE_MB = 1;
export const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
export const ALLOWED_FILE_EXTENSIONS  = '.jpeg, .jpg, .png';
export const DIMENSIONS = '178 x 60 pixels';